import { stringMasterAchievement } from './helpers';

export default stringMasterAchievement(1, 'high E', 21);
